import Vue from 'vue';


// Private:

// Ersatt, se övrig kod:
//Array.prototype.withAllArrayItemsSetTo = function withAllArrayItemsSetTo(value) {
//	return this.map(function() { return value; });		// Fill stöds *inte* av IE: Array(arraySize).fill(value);
//};

// Vuex store mutation methods do not provide direct access to getters.
// Workaround: En "ren" metod som i sin tur används av både store gettern och store mutation:
// Denna la jag som en js-function utanför export-modulen, för att göra den "private":

//const gruppenArExpanderadSUB = (state) => (gruppensElementName) => {
function gruppenArExpanderadSUB(state, gruppensElementName) {

	// js-variant of linq firstOrDefault():https://gist.github.com/DanDiplo/30528387da41332ff22b:
	const item = state.expanderadeGrupper.filter((item) => { return item === gruppensElementName; })[0] || null;

	return !!item;
}



//============================================================


// Denna modul är "reusable" och används av apparna för Resultat, Tillgångar och Skulder:
const modul = {
	namespaced: true,

	// Denna är en function för att denna modul ska kunna vara "reusable" och används av flera appar/sidor::
	state () {
		return {
			// Dessa används endast "vid bakåt-/framåtnavigering i webbläsarens history" (back/forward history). Vid annan navigering till sidan används istället de sparade standardinställningarna för företaget (Bevarande-poster i SQL-tabell):
			// Eller uttryckt på ett mer pseudo-kod-likt sätt: Dessa används alltid. Vid *annan* typ av navigering till sidan än back/forward history "nollas" de till de sparade standardinställningarna:
			// Av den anledningen behöver de inte ha något "initialt" värde nedan:
			tommaPosterVisas: undefined,
			expanderadeGrupper: undefined,

			// Ersatt med ovan:
			//// Indexerad 0–n enligt respektive grupps gruppIndex-värde:
			//// Obs! Indexmetoden, snarare än unika-gruppnamn-metoden, funkar eftersom livslängden på denna persistens begränsas till "vid bakåt-/framåtnavigering i webbläsarens history" (back/forward history). Värdena bör dock nollas då företag/r-år byts, vilket sköts med separat property nedan.
			//// Todo: Fuuuling!! Storleken satt till fast värde, "mer-än-vad-som-någonsin-kommer-att-behövas":
			//gruppExpanderad: Array(1000).withAllArrayItemsSetTo(false),	// Initialt defaultvärde.

			// Todo: Väntar med detta! Kanske ska skötas på annat sätt efter kommande persistens-beslut!!!! Kan ex.vis också tänka sig att man persisterar per företag eller per företag+r-år. Se även kommentar ovan.
			// Invalideringsmekaniskmen för inkorporeras i denna modul!
			//gruppExpanderadGallerFor: "",		// Sätts vid varje initiering av appen, plus används för att detektera om de persisterade värdena ovan ska invalideras/inte.

			rullningsbaraElement: [ 	// = initiala defaultvärden
				{ id:'re1', scrollTop: 0 },
			],
		};
	},

	getters: {
		// Method-Style Access:
		// Note that getters accessed via methods will run each time you call them, and the result is not cached:

		// Anrop: store.getters.gruppenArExpanderad('Elementnamnet');
		gruppenArExpanderad: (state) => (gruppensElementName) =>
			gruppenArExpanderadSUB(state, gruppensElementName),
	},

	mutations: {

		setTommaPosterVisas(state, nyttVarde) {
			state.tommaPosterVisas = nyttVarde;
		},

		setExpanderadeGrupper(state, nyttVarde) {
			// Värde är en array (by ref), så här clonar vi denm istället:
			//state.expanderadeGrupper = nyttVarde;

			// Shallow copy(/clone):
			let [...klonAvNyttVarde] = nyttVarde;
			state.expanderadeGrupper = klonAvNyttVarde;

			// Deep copy(clone):
			// Behövs *inte* i detta fall:
			//state.expanderadeGrupper = JSON.parse(JSON.stringify(nyttVarde));
		},

		setGruppExpanderad(state, payload) {
			// Payload:
			//		.gruppensElementName,
			//		.nyttVarde,

			if (payload.nyttVarde)
			{
				// Om gruppen ska vara expanderad:
				// Lägg till den (om den inte redan finns):
				// (Ordningen är oviktig):

				if (!gruppenArExpanderadSUB(state, payload.gruppensElementName))
					state.expanderadeGrupper.push(payload.gruppensElementName);
			}
			else
			{
				// Annars, om den inte ska vara expanderad:
				// Ta bort den (om den finns):

				//let index = this.vpItems.map((item) => { return item.widgetId; }).indexOf(widgetId);
				//this.vpItems.splice(index, 1);

				let index = state.expanderadeGrupper.indexOf(payload.gruppensElementName);

				if (index !== -1)
					state.expanderadeGrupper.splice(index, 1);
			}

			// Ersatt, se övrig kod:
			//// https://vuejs.org/v2/guide/list.html#Caveats: Due to limitations in JavaScript, Vue cannot detect (is NOT reactive) when you directly set an array-item with the index, e.g. vm.items[indexOfItem] = newValue.
			////state.gruppExpanderad[gruppIndex] = nyttVarde;
			//Vue.set(state.gruppExpanderad, payload.gruppIndex, payload.nyttVarde);
		},


		// Ersatt, se övrig kod:
		//invalideraAllaGruppExpanderad(state) {
		//	state.gruppExpanderad = state.gruppExpanderad.withAllArrayItemsSetTo(false);
		//},

		// Ersatt, se övrig kod:
		//setGruppExpanderad(state, payload) {
		//	// https://vuejs.org/v2/guide/list.html#Caveats: Due to limitations in JavaScript, Vue cannot detect (is NOT reactive) when you directly set an array-item with the index, e.g. vm.items[indexOfItem] = newValue.
		//	//state.gruppExpanderad[gruppIndex] = nyttVarde;
		//	Vue.set(state.gruppExpanderad, payload.gruppIndex, payload.nyttVarde);
		//},

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	},

	//actions: { ... },
};

export { modul as ssoStatestoreRapport };
